import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientActions } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const {
  FAILURE_PATIENT_IN_ACTIVE_COUNT,
  REQUEST_PATIENT_IN_ACTIVE_COUNT,
  SUCCESS_PATIENT_IN_ACTIVE_COUNT,
  SUCCESS_PATIENT_IN_ACTIVE_COUNT_LOADING,
} = PatientActions;

function* getPatientInOrActiveCounts(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: SUCCESS_PATIENT_IN_ACTIVE_COUNT_LOADING });
    const response = yield call(patientService.getPatientActiveInActiveCounts, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_PATIENT_IN_ACTIVE_COUNT, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_PATIENT_IN_ACTIVE_COUNT, payload: error });
  }
}

function* getPatientInOrActiveCountsSaga() {
  yield takeEvery(REQUEST_PATIENT_IN_ACTIVE_COUNT, getPatientInOrActiveCounts);
}

export default getPatientInOrActiveCountsSaga;
